import React, { FunctionComponent } from 'react';
import { Col, Container, Link, Row } from '@visalex/core';

import { Trans, useTranslation } from 'next-i18next';

import styles from './WhyVisalexAdvantages.module.scss';

const prefix = 'why-visalex';

const WhyVisalexAdvantages: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <section className={styles[`${prefix}__advantages`]} data-testid="why-visalex-advantages">
      <Container>
        <Row>
          <Col xs={12} md={5} className="order-1 order-md-0">
            <div>
              <h3>{t(`${prefix}.when-we-say`)}</h3>
              <p>
                <Trans i18nKey={`${prefix}.visalex-helps-intro`}>
                  VisaLex helps you build the <span>strongest possible</span> case for your
                </Trans>{' '}
                <Link className="regular-link" href="/green-cards">
                  {t(`${prefix}.visalex-helps-gc`)}
                </Link>
                {', '}
                <Link className="regular-link" href="/visas">
                  {t(`${prefix}.visalex-helps-wv`)}
                </Link>{' '}
                <Trans i18nKey={`${prefix}.visalex-helps-rest"`}>
                  or travel authorization — <span>without all the work, frustration, and uncertainty</span> of going it
                  alone or relying on a traditional law firm. Our unrelenting commitment to excellence has enabled us to
                  achieve a <span>97% success rate.</span>
                </Trans>
              </p>
            </div>
          </Col>
          <Col xs={12} md={{ span: 6, offset: 1 }} className="order-0 order-md-1">
            <img src="/images/why-visalex.png" alt={t(`${prefix}.imageAlt.visalex-help`)} />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <img src="/images/why-visalex-illustration-2.png" alt={t(`${prefix}.imageAlt.visalex-revolutionizing`)} />
          </Col>
          <Col xs={12} md={{ span: 5, offset: 1 }}>
            <div>
              <h3>{t(`${prefix}.revolutionizing`)}</h3>
              <div className={styles[`${prefix}__revolutionizing`]}>
                <Trans i18nKey={`${prefix}.unique-combination.title`}>
                  VisaLex offers a <span>unique combination</span> of benefits:
                </Trans>
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: t(`${prefix}.unique-combination.items.0`) }}></li>
                  <li dangerouslySetInnerHTML={{ __html: t(`${prefix}.unique-combination.items.1`) }}></li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default WhyVisalexAdvantages;
